import {$, w} from './constants';
import { sliderGrab, sameHeightSliders, initializeSidebarSliders, sliderEvents, initializeSliderPodcast } from './sliders.js';
import { tooltipInit, tooltipInitTippy } from './tooltip.js';
import { timersPosts } from './update-timer.js';
import './app.js';
import './news.js';
import './marquee';
import './youtube.js';
import './calendar.js';
import './podcast.js';
import './terminal.js';


timersPosts();

w.load(() => {

    console.log('Hello world from El Cultivo! --Load');
    sliderGrab();
    if( $('.sliders_height').length ){
        sameHeightSliders($('.sliders_height'));
    }

    // Home Fatured Video
    document.querySelectorAll('.home_play_JS').forEach(button => {
        button.addEventListener('click', function() {
            const card = button.closest('.card__event-home');
            const iframeContainer = card.querySelector('.home_iframe_JS');
            const textarea = card.querySelector('.home_textarea_JS');
            if (textarea && iframeContainer) {
                iframeContainer.innerHTML = textarea.value;
                iframeContainer.style.display = 'block';
            }
            const image = card.querySelector('.image');
            if (image) image.style.display = 'none';
        });
    });

    if( $('.home__events').length ){

        ajustarAlturaImagen()

        // Escuchar cambios en tamaño de ventana
        $(window).on('resize', function () {
            ajustarAlturaImagen()
        });

        // Cambios de filtros
        $('.home__events-tabs-filter').on('click', function () {
            console.log('click desde resize')
            ajustarAlturaImagen()
        });

        // Usar ResizeObserver para detectar si cambia el contenido de la columna derecha
        if (window.ResizeObserver) {
            let $rightColumn = $('.home__events-tabs');
            const observer = new ResizeObserver(() => {
                ajustarAlturaImagen()
            });

            observer.observe($rightColumn.get(0));
        }
    }

    //Cards en Archive
    if( $('#grid_container').length ){
        setTimeout(function() {
            requestAnimationFrame(function() {
                igualarAlturas();
            });
        }, 100);
    }

    //Scroll en paginación Archive
    if (window.location.pathname.includes('/page/')) {
        setTimeout(function() {
            const $target = $('#grid_wrapper');
            if ($target.length) {
                $('html, body').animate({
                    scrollTop: $target.offset().top - 130
                }, 500);
            }
        }, 300);
    }

    //Cards Eventos
    if( $('.sliders_height_events').length ){
        igualarAlturasEventos();
    }

    //Archive Eventos
    // Click en filtro de tipo (presencial / webinar)
    $('.events__grid-filters-block').on('click', function() {
        limpiarBusqueda();
        $('.events__grid-filters-block').removeClass('active');
        $(this).addClass('active');

        setCategoria('all', false);
        
        cargarEventos(null, categoriaActiva, 1);
    });

    // Cambio en el select de categorías
    $('#filter_category').on('change', function() {
        const slug = $(this).val();
        setCategoria(slug, true);
    });
    // Cambio en píldoras de categorías
    $('.filter_category_block').on('click', function () {
        const slug = $(this).data('filter');
        if ($(this).hasClass('active')) return;
        setCategoria(slug, true);
    });

    // Click en paginador (números)
    $(document).on('click', '.events__grid-pagination a.page-num', function(e) {
        e.preventDefault();
        const paged = $(this).data('page');
        if (paged) {
            cargarEventos(null, categoriaActiva, paged);
        }
    });

    // Botón anterior / siguiente
    $(document).on('click', '.btn--prev-events, .btn--next-events', function(e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return;
        const paged = $(this).data('page');
        if (paged) {
            cargarEventos(null, categoriaActiva, paged);
        }
    });

    if( $('#archive_events').length){
        cargarEventos(null, categoriaActiva, 1);
    }

    //Slider Archivo
    if( $('#events_slider').length ){
        sliderEvents($('#events_slider'));
    }

    //Búsqueda Archivo
    $('#search_events_form').on('submit', function(e) {
        e.preventDefault();

        const searchTerm = $('#search_events').val();
        const categoria = $('#filter_category').val() || 'all';

        buscarEventos(searchTerm, null, categoria, 1);
    });

    // Click en paginador (números)
    $(document).on('click', '.events__grid-pagination a.page-num-search', function(e) {
        e.preventDefault();
        const paged = $(this).data('page');
        const searchTerm = $('#search_events').val();
        const categoria = $('#filter_category').val() || 'all';
        if (paged) {
            buscarEventos(searchTerm, null, categoria, paged);
        }
    });

    // Botón anterior / siguiente
    $(document).on('click', '.btn--prev-events-search, .btn--next-events-search', function(e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return;
        const paged = $(this).data('page');
        const searchTerm = $('#search_events').val();
        const categoria = $('#filter_category').val() || 'all';
        if (paged) {
            buscarEventos(searchTerm, null, categoria, paged);
        }
    });

    //Vistas
    $('#grid_compact_events').on('click', function(){
        $('#grid_wide_events').removeClass('active');
        $('#grid_compact_events').addClass('active');
        $('#grid_container_events > .events__grid-blocks').addClass('events__grid-blocks--compact');
        igualarAlturasEventosGrid(3);
        currentView = 'compact';
    });
    $('#grid_wide_events').on('click', function(){
        $('#grid_compact_events').removeClass('active');
        $('#grid_wide_events').addClass('active');
        $('#grid_container_events > .events__grid-blocks').removeClass('events__grid-blocks--compact');
        igualarAlturasEventosGrid(2);
        currentView = 'wide';
    });

    //Tipo Archivo
    $('.filter_news').on('click', function(e){
        e.preventDefault();

        const tipo = $(this).data('news'); // "Online Report" o "News"
        $('.filter_news').removeClass('active');
        $(this).addClass('active');

        // Mostrar/ocultar contenedores según el tipo
        if (tipo === 'Online Report') {
            $('#grid_container_market').show();
            $('#grid_container_latest').hide();
        } else {
            $('#grid_container_latest').show();
            $('#grid_container_market').hide();
        }

        // Resetear paginación al primer page
        const tipoMapped = tipo === 'Online Report' ? 'Online Report' : 'News';
        cargarNoticias(6, tipoMapped, 1);
    });

    //Archivo Podcast
    if( $('#archive_podcast').length){
        cargarPodcasts(categoriaActivaPodcast, 1);
    }

    //Cambio en el pill de categoría
    $('.filter_category_podcast').on('click', function(){
        $('.filter_category_podcast').removeClass('active');
        $(this).addClass('active');
        categoriaActivaPodcast = $(this).data('filter');
        $('#filter_category_podcast').val(categoriaActivaPodcast); // sincroniza móvil
        cargarPodcasts(categoriaActivaPodcast, 1); 
    });
    // Cambio en el select de categorías
    $('#filter_category_podcast').on('change', function() {
        categoriaActivaPodcast = $(this).val();
        $('.filter_category_podcast').removeClass('active');
        $('.filter_category_podcast[data-filter="' + categoriaActivaPodcast + '"]').addClass('active'); // sincroniza desktop
        cargarPodcasts(categoriaActivaPodcast, 1); // Reinicia paginador
    });

    // Botón anterior / siguiente
    $(document).on('click', '.btn--prev-podcast, .btn--next-podcast', function(e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return;
        const paged = $(this).data('page');
        if (paged) {
            cargarPodcasts(categoriaActivaPodcast, paged);
        }
    });

    // Click en paginador (números)
    $(document).on('click', '.podcast__grid-pagination a.page-num', function(e) {
        e.preventDefault();
        const paged = $(this).data('page');
        if (paged) {
            cargarPodcasts(categoriaActivaPodcast, paged);
        }
    });

    //Podcast Home
    if( $('#category_podcast_grid').length){
        cargarPodcastsHome(categoriaActivaPodcastHome);
    }
    //Cambio en el pill de categoría
    $('.filter_category_podcast_home').on('click', function(){
        $('.filter_category_podcast_home').removeClass('active');
        $(this).addClass('active');
        categoriaActivaPodcastHome = $(this).data('filter');
        $('#filter_category_podcast_home').val(categoriaActivaPodcastHome); // sincroniza móvil
        cargarPodcastsHome(categoriaActivaPodcastHome); 
    });
    // Cambio en el select de categorías
    $(document).on('touchend change', '#filter_category_podcast_home', function (e) {
        if (e.type === 'touchend') return;
        e.preventDefault();
        e.stopPropagation();

        categoriaActivaPodcastHome = $(this).val() || 'all';

        $('.filter_category_podcast_home').removeClass('active');
        $('.filter_category_podcast_home[data-filter="' + categoriaActivaPodcastHome + '"]').addClass('active');

        cargarPodcastsHome(categoriaActivaPodcastHome);

        return false;
    });

    //Single Eventos
    if( $('.sliders_events').length ){
        igualarAlturasEventos();
    }

    //Archivo Noticias
    if( $('#archive_news').length){
        cargarNoticias(6, 'Online Report', 1);
        cargarNoticias(6, 'News', 1);
    }

    //Paginación Archivo
    $(document).on('click', '.page-num-market, .btn--prev-market, .btn--next-market', function(e) {
        e.preventDefault();
        const paged = parseInt($(this).data('page'));
        cargarNoticias(6, 'Online Report', paged);
    });
    
    $(document).on('click', '.page-num-latest, .btn--prev-latest, .btn--next-latest', function(e) {
        e.preventDefault();
        const paged = parseInt($(this).data('page'));
        cargarNoticias(6, 'News', paged);
    });

    
    /* A C A D E M Y */
    if( $('#grid_container_academy').length){
        let cat = $('#category').val();
        cargarAcademy( cat, 1);
    }
     // Click en paginador (números)
    $(document).on('click', '.academy-archive__grid-pagination a.page-num', function(e) {
        e.preventDefault();
        const paged = $(this).data('page');
        let cat = $('#category').val();
        if (paged) {
            cargarAcademy(cat, paged);
        }
    });

    // Botón anterior / siguiente
    $(document).on('click', '.btn--prev-academy, .btn--next-academy', function(e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return;
        let cat = $('#category').val();
        const paged = $(this).data('page');
        if (paged) {
            cargarAcademy( cat, paged);
        }
    });

    $('#filter_category_academy').on('change', function () {
        const url = $(this).val();
        if (url) {
        window.location.href = url;
        }
    });

    if($('.sliders_height_academy').length){
        igualarAlturasAcademySlider()
    }
    /* END A C A D E M Y */
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');

    //tooltipInit();
    tooltipInitTippy();
    
    //Menú Home
    // Submenú Home: detección por línea de referencia (una sola activa)
    if ($('#menu_home_sections').length) {

        const menuWrap = document.getElementById('menu_home_sections');
        const menuItems = Array.from(
            document.querySelectorAll('#menu_home_sections .menu_section')
        );

        const sectionIds = menuItems
            .map(item => item.dataset.section)
            .filter(Boolean);

        const sections = sectionIds
            .map(id => document.getElementById(id))
            .filter(Boolean);

        if (sections.length) {

            // Offset fijo: 225 desktop / 205 mobile
            function getStickyOffset() {
                return window.matchMedia('(max-width: 950px)').matches
                    ? 205
                    : 225;
            }

            // Línea de referencia para determinar la sección activa
            function getRefY() {
                const offset = getStickyOffset();
                const viewportPosition = Math.round(window.innerHeight * 0.20);
                const clampedPosition = Math.min(
                    Math.max(viewportPosition, 80),
                    160
                );

                return offset + clampedPosition;
            }

            let activeId = null;
            let ticking = false;

            function centerActiveMenuItem(item) {
                if (!menuWrap || !item) return;

                const maxScrollLeft =
                    menuWrap.scrollWidth -
                    menuWrap.clientWidth;

                const targetLeft =
                    item.offsetLeft -
                    (menuWrap.clientWidth / 2) +
                    (item.offsetWidth / 2);

                const normalizedLeft = Math.min(
                    Math.max(0, targetLeft),
                    Math.max(0, maxScrollLeft)
                );

                menuWrap.scrollTo({
                    left: normalizedLeft,
                    behavior: 'smooth'
                });
            }

            function setActive(id) {
                if (activeId === id) return;

                activeId = id;

                menuItems.forEach(item => {
                    const isActive = item.dataset.section === id;

                    item.classList.toggle('active', isActive);

                    if (isActive) {
                        centerActiveMenuItem(item);
                    }
                });
            }

            function computeActive() {
                const refY = getRefY();
                let winner = null;

                // Busca la sección que cruza la línea de referencia
                for (const section of sections) {
                    const rect = section.getBoundingClientRect();

                    if (
                        rect.top <= refY &&
                        rect.bottom >= refY
                    ) {
                        winner = section;
                        break;
                    }
                }

                // Si hay espacios entre secciones, usa la más cercana
                if (!winner) {
                    let nearest = null;
                    let minimumDistance = Infinity;

                    for (const section of sections) {
                        const rect = section.getBoundingClientRect();

                        const distance = Math.min(
                            Math.abs(rect.top - refY),
                            Math.abs(rect.bottom - refY)
                        );

                        if (distance < minimumDistance) {
                            minimumDistance = distance;
                            nearest = section;
                        }
                    }

                    winner = nearest;
                }

                if (winner) {
                    setActive(winner.id);
                }
            }

            function onScroll() {
                if (ticking) return;

                ticking = true;

                window.requestAnimationFrame(function () {
                    computeActive();
                    ticking = false;
                });
            }

            window.addEventListener('scroll', onScroll, {
                passive: true
            });

            window.addEventListener('resize', onScroll);

            computeActive();

            // Scroll suave hacia las secciones del Home
            $(document).on(
                'click',
                '#menu_home_sections a',
                function (event) {

                    const hash = this.hash;

                    if (
                        !hash ||
                        hash === '#' ||
                        hash === '#0'
                    ) {
                        return;
                    }

                    const url = new URL(
                        this.href,
                        window.location.href
                    );

                    const currentPath =
                        window.location.pathname
                            .replace(/\/+$/, '');

                    const targetPath =
                        url.pathname
                            .replace(/\/+$/, '');

                    // Los enlaces hacia otras páginas siguen normales
                    if (
                        url.origin !== window.location.origin ||
                        targetPath !== currentPath
                    ) {
                        return;
                    }

                    let target = null;

                    try {
                        target = document.querySelector(
                            '#' + CSS.escape(hash.substring(1))
                        );
                    } catch (error) {
                        target = document.getElementById(
                            hash.substring(1)
                        );
                    }

                    if (!target) {
                        return;
                    }

                    event.preventDefault();
                    event.stopPropagation();

                    const offset = getStickyOffset();

                    const targetY =
                        window.scrollY +
                        target.getBoundingClientRect().top -
                        offset;

                    window.scrollTo({
                        top: Math.max(0, targetY),
                        behavior: 'smooth'
                    });

                    history.replaceState(
                        null,
                        '',
                        hash
                    );

                    /*
                    * Ayuda a iOS a actualizar correctamente el activo
                    * al terminar o avanzar el scroll suave.
                    */
                    window.setTimeout(function () {
                        computeActive();
                    }, 700);
                }
            );

            window.addEventListener(
                'home:section-content-updated',
                function () {
                    computeActive();
                }
            );
        }
    }

    //Botón Regresar
	const $menuBack = $('.header__menu-back > a');
    if( $menuBack.length ){
        console.log( $menuBack)
        const $mobileBack = $('.btn--return[data-section-id]');
        console.log( $mobileBack)
        if ($mobileBack.length && $menuBack.length) {
            const sectionId = $mobileBack.data('section-id');
            const originalHref = $menuBack.attr('href');

            if (sectionId && originalHref) {
                $menuBack.attr('href', `${originalHref}#${sectionId}`);
            }
        }
    }
    

    // Toogle tabs
    $('.trigger_tabs_dropdown').on('click', function() {
        $(this).toggleClass('active');
        $(this).siblings('.target_tabs_dropdown').slideToggle(300);
        if ($(window).width() > 951){
            setTimeout(adjustCardHeight, 300); 
        }
    });

    // Navegación en botones
    $('.btn--next, .btn--prev').on('click', function () {
        if ($(this).hasClass('disabled')) return;

        let eventType = $(this).attr('id').split('_')[1]; // 'presencial' o 'webinar'
        let $block = $('.home__events-tabs-blocks[data-event="' + eventType + '"]');

        // Verifica que el bloque realmente exista en el DOM
        if (!$block.length) return;

        if ($(this).hasClass('btn--next')) {
            goToCard($block, 'next');
        } else {
            goToCard($block, 'prev');
        }
    });

    // Filtro de tabs
    $('.home__events-tabs-filter').on('click', function () {
        let target = $(this).data('event-filter');
        // Cambia el filtro activo
        $('.home__events-tabs-filter').removeClass('active');
        $(this).addClass('active');

        // Muestra solo el bloque de ese tipo
        $('.home__events-tabs-blocks').removeClass('active');
        $('.home__events-tabs-blocks[data-event="' + target + '"]').addClass('active');

        // Reset: muestra el primer card y actualiza botones
        let $block = $('.home__events-tabs-blocks[data-event="' + target + '"]');
        $block.find('.card__columns').removeClass('active').first().addClass('active');
        updatePaginator($block);
    });

    //Búsqueda
    $('#search_bar_open').on('click', function(){
        $('#search_bar').slideDown(300);
    });
    $('#search_bar_close').on('click', function(){
        $('#search_bar').slideUp(300);
    });

    //Sidebar
    if($('.sidebar-slider').length){
        initializeSidebarSliders($('.sidebar-slider'));
    }

    //Home Card Idea
    if( $('#grid_idea_home').length ){
        igualarAlturasIdeaHome();
    }

    //Archive Card Idea
    if( $('.card__archive--the-idea').length ){
        igualarAlturasIdeaArchive();
    }
    //Single Card Idea
    if( $('.card__single--the-idea').length ){
        igualarAlturasIdeaSingle();
    }

    //Archive Podcast Slider Banners
    if( $('#slider_banner_podcast').length ){
        initializeSliderPodcast($('#slider_banner_podcast'));
    }
});


//Scroll en links de misma página
$('a[href*="#"]')
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
    if ($(this).closest('#menu_home_sections').length) return;
	if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
		let target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

		if (target.length) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: target.offset().top - 140
			}, 1000);
		}
	}
});
$(window).on('load', function () {
	const hash = window.location.hash;

	if (hash) {
		const $target = $(hash);
         if ($(this).closest('#menu_home_sections').length) return;
		if ($target.length) {
			$('html, body').animate({
                scrollTop: $target.offset().top - 140
            }, 1000);
		}
	}
});


function adjustCardHeight() {
    if (window.innerWidth > 950) {
        var $tabs = $('.home__market-tabs');
        var $card = $('.card__event-home');
        var $image = $card.find('.image-container');
        var $data = $card.find('.data-container');

        $card.css('height', '');
        $image.css('height', '');

        var tabsHeight = $tabs.outerHeight();
        var cardHeight = $card.outerHeight();

        if (tabsHeight > cardHeight) {
            $card.css('height', tabsHeight + 'px');

            var dataHeight = $data.outerHeight();
            var newImageHeight = tabsHeight - dataHeight;

            if (newImageHeight > 0) {
                $image.css('height', newImageHeight + 'px');
            }
        }
    } else {
        $('.card__event-home, .card__event-home .image-container').css('height', '');
    }
}

$(document).ready(adjustCardHeight);
$(window).on('resize', adjustCardHeight);
$(window).on('load', adjustCardHeight);
$(window).on('resize', ()=>{
if($('.sliders_height_academy').length){
        igualarAlturasAcademySlider()
    }
});


function updatePaginator($block) {
    let $cards = $block.find('.card__columns');
    let $active = $cards.filter('.active');
    let index = $cards.index($active);
    let total = $cards.length;

    let eventType = $block.data('event');

    let $prevBtn = $('#btn_' + eventType + '_prev');
    let $nextBtn = $('#btn_' + eventType + '_next');

    $prevBtn.toggleClass('disabled', index === 0);
    $nextBtn.toggleClass('disabled', index === total - 1);
}

function goToCard($block, direction) {
    let $cards = $block.find('.card__columns');
    let $active = $cards.filter('.active');
    let currentIndex = $cards.index($active);

    let nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;

    if (nextIndex >= 0 && nextIndex < $cards.length) {
        $active.removeClass('active');
        $cards.eq(nextIndex).addClass('active');
        updatePaginator($block);
    }
}

function ajustarAlturaImagen() {
    let $imgContainer = $('.home__events-content-image .image-container');
    let $leftContent = $('.home__events-content');
    let $topLeft = $leftContent.find('.home__events-content-upper');
    let $rightColumn = $('.home__events-tabs');

    // Altura total de la columna derecha
    const alturaDerecha = $rightColumn.outerHeight();
    const alturaContenido = $topLeft.outerHeight();

    const alturaFinal = alturaDerecha - alturaContenido;

    if (alturaFinal > 0) {
        $imgContainer.css('height', alturaFinal + 'px');
    } else {
        $imgContainer.css('height', 'auto');
    }
}

function igualarAlturas() {
    let $containers = $('.card__archive .data-container');
    $containers.css('height', 'auto');
    $containers[0].offsetHeight;

    let maxHeight = 0;
    $containers.each(function() {
        let altura = $(this).outerHeight();
        if (altura > maxHeight) {
            maxHeight = altura;
        }
    });
    $containers.css('height', maxHeight);
}

function igualarAlturasEventos() {
    const clases = ['.upper-container', '.expert-container', '.data-container'];

    clases.forEach(function(clase) {
        let maxHeight = 0;

        $('.slider_event_block ' + clase).css('height', 'auto');

        $('.slider_event_block ' + clase).each(function() {
            let altura = $(this).outerHeight();
            if (altura > maxHeight) {
                maxHeight = altura;
            }
        });
        
        $('.slider_event_block ' + clase).css('height', maxHeight);
    });
}

function igualarAlturasEventosGrid(columns = 2) {
    if (window.innerWidth < 651){ return; }
    const clases = ['.title', '.expert-container', '.upper-container', '.data-container'];

    clases.forEach(function(clase) {
        // Reinicia alturas
        $('.event_grid_block ' + clase).css('height', 'auto');

        let items = $('.event_grid_block');

        for (let i = 0; i < items.length; i += columns) {
            let $rowItems = items.slice(i, i + columns);
            let maxHeight = 0;

            $rowItems.find(clase).each(function() {
                let altura = $(this).outerHeight();
                if (altura > maxHeight) maxHeight = altura;
            });

            $rowItems.find(clase).height(maxHeight);
        }
    });
}

function igualarAlturasAcademyGrid() {
if (window.innerWidth > 650) {
    const $blocks = $('#grid_container_academy .academy-archive__posts-block, #grid_container_academy .academy-archive__term');

    // Reset
    $blocks.find('.data-container, .title-container').css('height', 'auto');

    const rows = {};

    $blocks.each(function () {
      const $el = $(this);
      const top = Math.round($el.offset().top);

      if (!rows[top]) rows[top] = [];
      rows[top].push($el);
    });

    // Recorremos fila por fila
    Object.values(rows).forEach(group => {
      let maxData = 0;
      let maxTitle = 0;

      // Encontrar alturas máximas
      group.forEach($el => {
        const $data = $el.find('.data-container');
        const $title = $el.find('.title-container');

        if ($data.length) maxData = Math.max(maxData, $data.outerHeight());
        if ($title.length) maxTitle = Math.max(maxTitle, $title.outerHeight());
      });

      // Asignar alturas máximas a cada fila
      group.forEach($el => {
        $el.find('.data-container').css('height', maxData + 'px');
        $el.find('.title-container').css('height', maxTitle + 'px');
      });
    });
  } else {
    // Reset si es mobile
    $('#grid_container_academy .data-container, #grid_container_academy .title-container').css('height', 'auto');
  }
}
function igualarAlturasAcademySlider() {
  if (window.innerWidth > 650) {
    const $blocks = $('.single__related-slider-blocks--academy .academy-archive__posts-block');

    // Resetear alturas previas
    $blocks.find('.data-container, .title-container').css('height', 'auto');

    const rows = {};

    $blocks.each(function () {
      const $el = $(this);
      const top = Math.round($el.offset().top);

      if (!rows[top]) rows[top] = [];
      rows[top].push($el);
    });

    // Para cada fila encontrada
    Object.values(rows).forEach(group => {
      let maxData = 0;
      let maxTitle = 0;

      group.forEach($el => {
        const $data = $el.find('.data-container');
        const $title = $el.find('.title-container');

        if ($data.length) maxData = Math.max(maxData, $data.outerHeight());
        if ($title.length) maxTitle = Math.max(maxTitle, $title.outerHeight());
      });

      group.forEach($el => {
        $el.find('.data-container').css('height', maxData + 'px');
        $el.find('.title-container').css('height', maxTitle + 'px');
      });
    });
  } else {
    // Reset para mobile
    $('.single__related-slider-blocks--academy .data-container, .single__related-slider-blocks--academy .title-container').css('height', 'auto');
  }
}

function igualarAlturasIdeaHome(){
    if (window.innerWidth < 951){ return; }
    const clases = ['.title-container', '.content'];

    clases.forEach(function(clase) {
        let maxHeight = 0;

        $('.card__horizontal-home ' + clase).css('height', 'auto');

        $('.card__horizontal-home ' + clase).each(function() {
            let altura = $(this).outerHeight();
            if (altura > maxHeight) {
                maxHeight = altura;
            }
        });
        
        $('.card__horizontal-home ' + clase).css('height', maxHeight);
    });
}

function igualarAlturasIdeaArchive(){
    if (window.innerWidth < 951){ return; }

    const clases = ['.title-container', '.content'];

    clases.forEach(function(clase) {
        // Resetear alturas antes de calcular
        $('.card__archive--the-idea ' + clase).css('height', 'auto');

        let filas = [];
        let filaActual = [];
        let lastTop = null;

        // Agrupar elementos por fila
        $('.card__archive--the-idea').each(function(){
            const top = $(this).position().top;
            if (lastTop === null || Math.abs(top - lastTop) < 5) {
                filaActual.push(this);
            } else {
                filas.push(filaActual);
                filaActual = [this];
            }
            lastTop = top;
        });
        if (filaActual.length) filas.push(filaActual);

        // Para cada fila, igualar las alturas del bloque indicado
        filas.forEach(function(fila){
            let maxHeight = 0;

            fila.forEach(function(card){
                const $el = $(card).find(clase);
                const h = $el.outerHeight();
                if (h > maxHeight) maxHeight = h;
            });

            fila.forEach(function(card){
                $(card).find(clase).css('height', maxHeight);
            });
        });
    });
}

function igualarAlturasIdeaSingle(){
    if (window.innerWidth < 651){ return; }
    const clases = ['.title-container', '.excerpt-container'];

    clases.forEach(function(clase) {
        let maxHeight = 0;

        $('.card__single--the-idea ' + clase).css('height', 'auto');

        $('.card__single--the-idea ' + clase).each(function() {
            let altura = $(this).outerHeight();
            if (altura > maxHeight) {
                maxHeight = altura;
            }
        });
        
        $('.card__single--the-idea ' + clase).css('height', maxHeight);
    });
}

$(w).on('resize', function(){
    //Home Card Idea
    if( $('#grid_idea_home').length ){
        igualarAlturasIdeaHome();
    }
     //Archive Card Idea
    if( $('.card__archive--the-idea').length ){
        igualarAlturasIdeaArchive();
    }
    //Single Card Idea
    if( $('.card__single--the-idea').length ){
        igualarAlturasIdeaSingle();
    }
});

let tipoActivo = null;
let categoriaActiva = 'all';
let primeraCarga = true;
let currentView = 'wide';

if (window.innerWidth < 950) {
    currentView = 'wide';
}

function setCategoriaUI(slug) {
  $('.filter_category_block').removeClass('active');
  $('.filter_category_block[data-filter="' + slug + '"]').addClass('active');
  $('#filter_category').val(slug);
}

function setCategoria(slug, triggerLoad = true) {
  const valor = slug && slug.length ? slug : 'all';
  setCategoriaUI(valor);
  limpiarBusqueda();
  categoriaActiva = valor;
  if (triggerLoad) {
    cargarEventos(null, categoriaActiva, 1);
  }
}


function cargarEventos(tipoActivo, categoria, paged = 1) {
    console.log(tipoActivo);
        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: cltvo_js_vars.ajax_url,
            data: {
                action: 'events',
                tipo: tipoActivo,
                categoria: categoria,
                paged: paged,
                view: currentView
            },
            beforeSend: function() {
                $('#grid_container_events').addClass('loading');
            },
            success: function(response) {
                $('#grid_container_events').html(response);
                $('#grid_container_events').removeClass('loading');
                igualarAlturasEventosGrid(currentView === 'compact' ? 3 : 2);
                
                if (!primeraCarga) {
                    $('html, body').animate({
                        scrollTop: $('#grid-wrapper').offset().top - 170
                    }, 400);
                }

                primeraCarga = false;
            },
            error: function(xhr) {
                console.error('Error al cargar eventos:', xhr);
            }
        });
}

//Búsqueda Eventos
function limpiarBusqueda() {
    $('#search_events').val('');
}
function buscarEventos(termino, tipo, categoria, paged = 1) {
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: {
            action: 'events_search',
            s: termino,
            tipo: tipo,
            categoria: categoria,
            paged: paged,
            view: currentView
        },
        beforeSend: function() {
            $('#grid_container_events').addClass('loading');
        },
        success: function(response) {
            $('#grid_container_events').html(response);
            $('#grid_container_events').removeClass('loading');
            igualarAlturasEventosGrid(currentView === 'compact' ? 3 : 2);
            $('html, body').animate({
                scrollTop: $('#grid-wrapper').offset().top - 170
            }, 400);
        },
        error: function(xhr) {
            console.error('Error al buscar eventos:', xhr);
        }
    });
}

//Vistas Eventos
function aplicarVistaWide() {
    $('#grid_compact_events').removeClass('active');
    $('#grid_wide_events').addClass('active');
    $('#grid_container_events > .events__grid-blocks').removeClass('events__grid-blocks--compact');
    igualarAlturasEventosGrid(2);
    currentView = 'wide';
}
let lastWidth = window.innerWidth;

$(window).on('resize', function() {
    if( $('#archive_events').length){
        const width = window.innerWidth;

        if (width < 950 && lastWidth >= 950) {
            aplicarVistaWide();
        }

        lastWidth = width;
    }
});

let categoriaActivaPodcast = 'all';
let primeraCargaPodcast = true;

function cargarPodcasts(categoria, paged = 1) {
    $.ajax({
        url: cltvo_js_vars.ajax_url,
        type: 'POST',
        dataType: 'html',
        data: {
            action: 'podcast',
            categoria: categoria,
            paged: paged
        },
        beforeSend: function() {
            $('#grid_container_podcast').addClass('loading');
        },
        success: function(response) {
            $('#grid_container_podcast').html(response);
            $('#grid_container_podcast').removeClass('loading');
                //igualarAlturasPodcast();

            if (!primeraCargaPodcast) {
                $('html, body').animate({
                    scrollTop: $('#archive_podcast').offset().top - 100
                }, 400);
            }
            primeraCargaPodcast = false;
        },
        error: function(xhr) {
            console.error('Error al cargar podcasts:', xhr);
        }
    });
}

let categoriaActivaPodcastHome = 'all';
let primeraCargaPodcastHome = true;

function cargarPodcastsHome(categoria) {
    $.ajax({
        url: cltvo_js_vars.ajax_url,
        type: 'POST',
        dataType: 'html',
        data: {
            action: 'podcast_home',
            categoria: categoria
        },
        beforeSend: function() {
            $('#category_podcast_grid').addClass('loading');
        },
        success: function(response) {
            $('#category_podcast_grid').html(response);
            $('#category_podcast_grid').removeClass('loading');
            //igualarAlturasPodcast();

            if (!primeraCargaPodcastHome) {
                $('html, body').animate({
                    scrollTop: $('#podcast_grid').offset().top - 100
                }, 400);
            }
            primeraCargaPodcastHome = false;
            window.dispatchEvent(new Event('home:section-content-updated'));
        },
        error: function(xhr) {
            console.error('Error al cargar podcasts:', xhr);
        }
    });
}

let primeraCargaNews = {
    'Online Report': true,
    'News': true
};

function cargarNoticias(size = 6, tipo, paged = 1) {
    $.ajax({
        type: 'POST',
        dataType: 'html',
        url: cltvo_js_vars.ajax_url,
        data: {
            action: 'noticia',
            size: size,
            tipo: tipo,
            paged: paged
        },
        beforeSend: function() {
            $('#grid_container_news').addClass('loading');
        },
        success: function(response) {
            if (tipo === 'Online Report') {
                $('#grid_container_market').html(response);
            } else {
                $('#grid_container_latest').html(response);
            }

            if (!primeraCargaNews[tipo]) {
                $('html, body').animate({
                    scrollTop: $('#archive_news').offset().top - 170
                }, 400);
            }

            primeraCargaNews[tipo] = false;
        },
        error: function(xhr) {
            console.error('Error al cargar noticias:', xhr);
        }
    });
}

let primeraCargaAcademy = true;

function cargarAcademy(categoria, paged = 1) {
        $.ajax({
            type: 'POST',
            dataType: 'html',
            url: cltvo_js_vars.ajax_url,
            data: {
                action: 'academy',
                categoria: categoria,
                paged: paged
            },
            beforeSend: function() {
                $('#grid_container_academy').addClass('loading');
            },
            success: function(response) {
                $('#grid_container_academy').html(response);
                $('#grid_container_academy').removeClass('loading');
                igualarAlturasAcademyGrid()
                
                if (!primeraCargaAcademy) {
                    $('html, body').animate({
                        scrollTop: $('#grid_container_academy').offset().top - 170
                    }, 400);
                }

                primeraCargaAcademy = false;
            },
            error: function(xhr) {
                console.error('Error al cargar Academy:', xhr);
            }
        });
}

//Menú GBM
$('#open_gbm_menu').on('click', function(){
    $('#header_gbm').fadeIn(300);
});
$('#close_gbm_menu').on('click', function(){
    $('#header_gbm').fadeOut(300);
})
// Footer GBM
if($('.menu-item.footer_mobile_link').length ){
    updateFooterLogin();
}

const ua = navigator.userAgent || navigator.vendor || window.opera;

const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
const isAndroid = /android/i.test(ua);

// Incluye Safari, Chrome, Firefox u otro WebKit en iOS
const isMobileiOSBrowser = isIOS;

// Safari en macOS únicamente
const isSafariMac = ua.includes('Safari') && ua.includes('Macintosh') && !ua.includes('Chrome');

if (isMobileiOSBrowser) {
    $('#header_submenu').addClass('safari-fix');
} else if (isSafariMac) {
    $('#header_submenu').addClass('safari-mac');
} else if (isAndroid) {
    $('#header_submenu').addClass('android-fix');
}

//News Taxonomy
$('#filter_news_tab_market').on('click', function(){
    $('#grid_container_market').fadeIn(300);
    $(this).addClass('active');
    $('#filter_news_tab_news').removeClass('active');
    $('#grid_container_latest').fadeOut(300);
});
$('#filter_news_tab_news').on('click', function(){
    $('#grid_container_latest').fadeIn(300);
    $(this).addClass('active');
    $('#filter_news_tab_market').removeClass('active');
    $('#grid_container_market').fadeOut(300);
});

//Archivo Eventos
// Navegación
$('.btn--next-register, .btn--prev-register').on('click', function () {
  if ($(this).hasClass('disabled')) return;

  const eventType = $(this).attr('data-type'); // 'presencial' o 'webinar'
  const $block = $('.events__register-blocks[data-event="' + eventType + '"]');
  if (!$block.length) return;

  if ($(this).hasClass('btn--next-register')) {
    goToCard2($block, 'next');
  } else {
    goToCard2($block, 'prev');
  }
});

// Tabs
$('.events__register-filter').on('click', function () {
  const target = $(this).data('event-register');

  $('.events__register-filter').removeClass('active');
  $(this).addClass('active');

  $('.events__register-blocks').removeClass('active');
  const $block = $('.events__register-blocks[data-event="' + target + '"]').addClass('active');

  // Reset: primera card activa
  $block.find('.events__register-card').removeClass('active').first().addClass('active');
  updatePaginator2($block);
});

function updatePaginator2($block) {
  const $cards = $block.find('.events__register-card');
  const $active = $cards.filter('.active');
  const index = $cards.index($active);
  const total = $cards.length;

  const eventType = $block.data('event');
  const $prevBtn = $('.btn--prev-register[data-type="' + eventType + '"]');
  const $nextBtn = $('.btn--next-register[data-type="' + eventType + '"]');

  $prevBtn.toggleClass('disabled', index === 0);
  $nextBtn.toggleClass('disabled', index === total - 1);
}

function goToCard2($block, direction) {
  const $cards = $block.find('.events__register-card');
  const $active = $cards.filter('.active');
  const currentIndex = $cards.index($active);

  const nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
  if (nextIndex >= 0 && nextIndex < $cards.length) {
    $active.removeClass('active');
    $cards.eq(nextIndex).addClass('active');
    updatePaginator2($block);
  }
}
/*Comment to regenerate*/